import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./view/app";

/**
 * 描画先の `<div>` 要素
 */
const appElement = document.createElement("div");
appElement.id = "app";
document.body.appendChild(appElement);
document.body.id = "root";

/**
 * 描画する
 */
createRoot(appElement).render(React.createElement(App));
